import { isEmpty } from 'lodash'

import { getIsTestingOrder } from './testingOrders'
import { IOrderDetailsApiDto } from '../api'

const RECENT_ORDERS_LIST_SIZE = 5

const filterRecentOrdersValidPairsOnly = (recentOrdersData, availablePairs) => {
    const orderList = recentOrdersData?.results ?? ([] as IOrderDetailsApiDto[])

    if (isEmpty(orderList) || !availablePairs) return orderList

    return orderList
        .filter(orderData => {
            const { fromPairs, toPairs } = availablePairs

            const {
                pair,
                amount_quote: fromAmount,
                wallet_address: walletAddressDto = {},
            } = orderData
            const { quote, base } = pair
            const fromCode = quote.code
            const toCode = base.code

            const isTestingOrder = getIsTestingOrder({
                fromCode,
                toCode,
                fromAmount,
                walletAddress: walletAddressDto.address ?? '',
            })

            return (
                !isTestingOrder &&
                fromPairs[fromCode]?.includes(toCode) &&
                toPairs[toCode]?.includes(fromCode)
            )
        })
        .slice(0, RECENT_ORDERS_LIST_SIZE)
}

export { filterRecentOrdersValidPairsOnly }
